import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import InputLayout from "../../../../../../layout/InputLayout/InputLayout";
import TextToImageStepsSlider from "./Slider/TextToImageStepsSlider";

const TextToImageSteps = () => {
	const { t } = useTranslation("image_generation", { keyPrefix: "playground.textToImage.config.steps" });

	return (
		<InputLayout label={t("label")} info={t("info")}>
			<TextToImageStepsSlider />
		</InputLayout>
	);
};

export default observer(TextToImageSteps);
